import styled from 'styled-components'
import React from 'react'

export default ({children, onClose}) => (
  <ModalContainer>
    <ModalContent>
      <CloseButton onClick={onClose}><i className="fa fa-close"/></CloseButton>
      {children}
    </ModalContent>
  </ModalContainer>
)

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5000;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
`

const ModalContent = styled.div`
  position: relative;
  background: #fff;
  border-radius: 3px;
  padding: 40px 20px 10px;
  min-width: 30%;
  max-width: 90%;
`

const CloseButton = styled.span`
  position: absolute;
  right: 10px;
  top: 0;
  color: #ccc;
  font-size: 1.4rem;
`
